"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M11 7.917c0 1.604-1.35 2.916-3 2.916S5 9.521 4.999 7.917c0-1.605 1.35-2.917 3-2.917s3 1.312 3 2.917zM19 7.917c0 1.604-1.35 2.916-3 2.916s-3-1.312-3-2.916C13 6.312 14.35 5 16 5s3 1.312 3 2.917zM8 12.972c-2.35 0-7 1.118-7 3.403V19h14.143v-2.625c0-2.285-4.793-3.403-7.143-3.403zM15.143 13.556c.35-.049.558-.049.857-.049 2.35 0 7 .583 7 2.868V19h-6.285v-2.625c0-1.458-.422-1.993-1.572-2.82z" }), "Friends");
//# sourceMappingURL=Friends.js.map